import { Panel } from '@epam/promo';
import { Outlet } from 'react-router-dom';
import css from './PageLayout.module.scss';

export const PageLayout = () => (
  <Panel cx={css.page__container}>
    <Outlet />
  </Panel>
);
